import {Checkbox, Group} from '@mantine/core'

type SaveLocationCheckboxProps = {
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
}

export function SaveLocationCheckbox({checked, onChange, disabled}: SaveLocationCheckboxProps) {
    return (
        <Group gap="sm">
            <Checkbox
                label="Save for future use"
                description="Save this location to this customer's saved locations"
                checked={checked}
                onChange={(event) => onChange(event.currentTarget.checked)}
                disabled={disabled}
            />
        </Group>
    )
}
